(ns frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.controller
  (:require
   [frontend.ui.component.chart.map-charts :as map-chart]))

(defn portfolio-locations
  [topology {:keys [labels longitude latitude]}]
  (let [data (map (fn [label lon lat]
                    {:name label
                     :lon  lon
                     :lat  lat})
                  labels
                  longitude
                  latitude)
        config (map-chart/auto-locations-config
                map-chart/highmaps-nordic-countries-topo
                data)]
    config
  ))
